var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbicacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.695 0C2.10352 0.00286643 0.00308693 2.10286 0 4.69456C0 5.90353 0.936001 7.79538 2.78243 10.3176C3.5535 11.374 5.03478 11.6051 6.09117 10.834C6.28896 10.6896 6.46337 10.5154 6.60757 10.3176C8.45378 7.79538 9.39 5.90353 9.39 4.69456C9.38691 2.10308 7.2867 0.00286643 4.695 0ZM4.695 6.56568C3.65581 6.56568 2.81352 5.72317 2.81352 4.68419C2.81352 3.64522 3.65603 2.80271 4.695 2.80271C5.73397 2.80271 6.57648 3.64522 6.57648 4.68419C6.57648 5.72317 5.73397 6.56568 4.695 6.56568Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicacion);
export default __webpack_public_path__ + "static/media/ubicacion.251edaade897b18d8079456f1434c9d2.svg";
export { ForwardRef as ReactComponent };